import { createContext } from "react";

interface DataTableColumnVisibility {
  columnVisibility: Record<string, boolean>;
  resetColumnVisibility: () => void;
}

const DataTableColumnVisibilityContext =
  createContext<DataTableColumnVisibility | null>(null);

export default DataTableColumnVisibilityContext;
